import React from "react";
import { Admin, Resource, ListGuesser } from "react-admin";
import {
  FirebaseAuthProvider,
  FirebaseDataProvider,
} from "react-admin-firebase";
import firebaseConfig from "./FIREBASE_CONFIG";
import { Route } from "react-router-dom";
import {
  Layout,
  UserList,
  UserEdit,
  TankList,
  TankCreate,
  TankEdit,
  BrandList,
  BrandCreate,
  BrandEdit,
  ProductList,
  ProductCreate,
  ProductEdit,
  ContactMessageList,
  ContactMessageShow,
  SystemEdit,
  PlaceList,
  PlaceCreate,
  PlaceEdit,
} from "./components";
import LoginPage from "./pages/LoginPage";
import { createTheme } from "@material-ui/core/styles";
import TransferOrderList from "./components/TransferOrder/TransferOrderList";
import TransferOrderShow from "./components/TransferOrder/TransferOrderShow";
import TransferOrderEdit from "./components/TransferOrder/TransferOrderEdit";
import ProductOrderList from "./components/ProductOrder/ProductOrderList";
import Dashboard from "./components/Dashboard";

const options = {
  logging: true,
  rootRef: "",
};

const dataProvider = FirebaseDataProvider(firebaseConfig, options);
const authProvider = FirebaseAuthProvider(firebaseConfig, options);

const theme = createTheme({
  palette: {
    type: "light",
    primary: {
      main: "#ff0000",
    },
    secondary: {
      main: "#262626",
    },
  },
});

function App() {
  return (
    <Admin
      theme={theme}
      loginPage={LoginPage}
      dataProvider={dataProvider}
      authProvider={authProvider}
      customRoutes={[
        <Route key="dashboard" path="/dashboard" component={Dashboard} />,
        <Route key="settings" path="/settings" component={SystemEdit} />,
      ]}
      layout={Layout}
      // dashboard={Dashboard}
    >
      <Resource
        name="users"
        list={UserList}
        // create={UserCreate}
        edit={UserEdit}
      />
      <Resource
        name="tanks"
        list={TankList}
        create={TankCreate}
        edit={TankEdit}
      />
      <Resource
        name="brands"
        list={BrandList}
        create={BrandCreate}
        edit={BrandEdit}
      />
      <Resource
        name="places"
        list={PlaceList}
        create={PlaceCreate}
        edit={PlaceEdit}
      />
      <Resource
        name="products"
        list={ProductList}
        create={ProductCreate}
        edit={ProductEdit}
      />
      <Resource
        name="transferOrders"
        list={TransferOrderList}
        show={TransferOrderShow}
        edit={TransferOrderEdit}
      />
      <Resource name="productOrders" list={ProductOrderList} />
      <Resource
        name="contactMessages"
        list={ContactMessageList}
        show={ContactMessageShow}
      />
      <Resource name="system" />
      <Resource name="runningResults" />
    </Admin>
  );
}

export default App;
